<template>
  <v-form :value="isValid" @input="$emit('update:isValid', $event)" :disabled="isLessThanTwoSelected">
    <v-tooltip bottom color="font" :disabled="!isLessThanTwoSelected">
      <template #activator="{ on }">
        <span v-on="on">
          <field-calculator-row
            class="pt-4"
            v-for="row in computedRows"
            v-bind="{ ...$props, ...row }"
            :key="row.id"
            v-on="$listeners"
            :attribute="row.attribute"
            :value="row.value"
            :is-valid="isValid"
          ></field-calculator-row>
        </span>
      </template>
      {{ $i18n.t('sidebar.fieldCalculator.selectFeaturesToEdit') }}
    </v-tooltip>
  </v-form>
</template>

<script>
import FieldCalculatorRow from '@/components/FieldCalculatorRow';

export default {
  name: 'FieldCalculator',
  components: {
    FieldCalculatorRow,
  },
  props: {
    attributes: {
      type: Array,
      required: true,
    },
    relationalAttributesValues: {
      type: Array,
      default: () => [],
    },
    value: {
      type: Array,
      required: true,
    },
    isValid: {
      type: Boolean,
      default: true,
    },
    isLessThanTwoSelected: {
      type: Boolean,
      default: true,
    },
    isDataSourceUseAttributesQualifiedNames: {
      type: Boolean,
      required: true,
    },
  },
  data: () => ({}),
  computed: {
    computedRows() {
      return this.value.map((value, index, array) => {
        const newAttributes = this.value.filter(v => v.attribute !== value.attribute).map(v => v.attribute);
        return {
          ...value,
          attributes: this.attributes.filter(attr => !newAttributes.includes(attr.attribute)),
          hasAddButton: this.getHasAddButton(index, array),
          hasDeleteButton: index > 0,
          index,
        };
      });
    },
  },
  methods: {
    getHasAddButton(index, array) {
      return (index === 0 && array.length === 1) || index === array.length - 1;
    },
  },
};
</script>

<style lang="scss" scoped></style>
